import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AppConfig } from '../../appconfig';

@Component({
  selector: 'lfw-about-page',
  templateUrl: './about-page.component.html',
  styleUrl: './about-page.component.scss',
  imports: [TranslatePipe]
})
export class AboutPageComponent {
  private readonly config = inject(AppConfig);

  get appVersion(): string {
    return this.config.frontendVersion();
  }

  get apiVersion(): string {
    return this.config.apiVersion();
  }

  get hasServerInfo(): boolean {
    return this.config.hasServerInfo();
  }

  get serverInfo(): string {
    return this.config.serverInfo();
  }

  get hasImprint(): boolean {
    return this.config.hasImprintLink();
  }

  get urlImprint(): string {
    return this.config.urlImprint();
  }

  get textImprint(): string {
    return this.config.textImprint();
  }

  get hasPrivacy(): boolean {
    return this.config.hasPrivacyLink();
  }

  get urlPrivacy(): string {
    return this.config.urlPrivacy();
  }

  get textPrivacy(): string {
    return this.config.textPrivacy();
  }
}
